import { useViewer } from "@/authentication/ViewerProvider"
import { useMemo } from "react"

export const useCurrentOrganization = () => {
  const { viewer, loading } = useViewer()

  // In the future that supports multitenancy, we should store the current organization in a session or something.
  const membership = useMemo(
    () => viewer?.organizationMemberships?.[0],
    [viewer],
  )

  return {
    loading,
    membership,
    organization: membership?.organization,
  }
}
